module.exports = [{
      plugin: require('/Users/byron/dev/bywo.gatsby/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/byron/dev/bywo.gatsby/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
